import clsx, { ClassValue } from 'clsx';

export function cn(...classes: ClassValue[]): string {
  return clsx(...classes);
}

export function formatPrice(amount: number | string): string {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(isNaN(num) ? 0 : num);
}

export function formatDate(date: string): string {
  return new Intl.DateTimeFormat('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(date));
}

export function formatDateTime(date: string): string {
  return new Intl.DateTimeFormat('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
}

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';
const STORAGE_BASE = API_BASE.replace('/api/v1', '');

export function getImageUrl(path: string | null): string {
  if (!path) return '/images/placeholder.svg';
  if (path.startsWith('http')) return path;
  const clean = path.replace(/^\/+/, '');
  return `${STORAGE_BASE}/storage/${clean}`;
}

export function getProductImage(product: { images?: { image_path: string }[]; slug?: string } | null | undefined): string {
  if (product?.images?.[0]?.image_path) {
    return getImageUrl(product.images[0].image_path);
  }
  return `${STORAGE_BASE}/api/v1/placeholder/product/${product?.slug || 'default'}`;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounce<T extends (...args: any[]) => any>(
  fn: T,
  delay: number
): (...args: Parameters<T>) => void {
  let timer: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

export function truncate(str: string, length: number): string {
  if (str.length <= length) return str;
  return str.slice(0, length) + '...';
}

export function slugify(str: string): string {
  return str
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
